import Result from './src/result.mjs';
export { IconComponentMap, IconMap, resultProps } from './src/result2.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElResult = withInstall(Result);

export { ElResult, ElResult as default };
//# sourceMappingURL=index.mjs.map
